import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBq2Sz2471gxBTLKxy1tgsFvRifIbJjvB8",
  authDomain: "streetwise-tv.firebaseapp.com",
  projectId: "streetwise-tv",
  storageBucket: "streetwise-tv.firebasestorage.app",
  messagingSenderId: "718888289848",
  appId: "1:718888289848:web:33b4e481eff834fb42c8cd"
};

// App initialisieren
const app = initializeApp(firebaseConfig);

// Exporte für die App
export const auth = getAuth(app);
export const storage = getStorage(app);

// Firestore mit Long-Polling für maximale Stabilität in CodeSandbox
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
